<div class="lenexa-stepper-horizontal">
  <div class="lenexa-step" [ngClass]="{'active': step.active, 'done': step.done }"
    *ngFor="let step of steps; let i = index;">
    <div class="lenexa-step-circle"><span>{{i + 1}}</span></div>
    <div class="lenexa-step-title">{{ step.name | translate}}</div>
    <div class="lenexa-step-bar-left"></div>
    <div class="lenexa-step-bar-right"></div>
  </div>
</div>